import React from "react";
import { useFormContext } from "react-hook-form";
import { UseFormRegisterReturn } from "react-hook-form/dist/types";
import { spacing } from "../../styleConfig";
import * as C from "./styles";

interface Props<T> {
  error?: boolean;
  errorMsg?: string;
  containerStyle?: React.CSSProperties;
  placeholder?: string;
  type?: string;
  disabled?: boolean;
  formName?: keyof T;
  icon?: JSX.Element;
}

export default function FormInput<Type>({
  error,
  errorMsg,
  containerStyle,
  placeholder,
  type,
  formName,
  disabled,
  icon
}: Props<Type>) {
  const [wasFocused, setWasFocused] = React.useState<boolean>(false);

  const wasFocusedStyle: React.CSSProperties = {
    transform: "translateY(50%)",
    top: "-60%",
    left: "0%",
    fontSize: "13px",
    paddingRight: spacing(1.2),
  };
  const methods = useFormContext();

  React.useEffect(() => {
    if (type === "date") {
      setWasFocused(true);
    }
  }, [wasFocused]);

  return (
    <C.MainContainer wasFocused={wasFocused} style={containerStyle}>
      <C.InputContainer>
        <C.Input
          disabled={disabled}
          type={type ?? "text"}
          role="form"
          error={error}
          errorMsg={errorMsg}
          onFocus={() => setWasFocused(true)}
          autoComplete="off"
          step="0.01"
          {...methods.register(formName as string ?? "", {
            onBlur: (e) =>
              e.target.value.length > 0
                ? setWasFocused(true)
                : setWasFocused(false),
          })}
        />
        <C.InputLabel
          onClick={(e) => methods.setFocus(formName as string ?? "")}
          error={error}
          errorMsg={errorMsg}
          style={wasFocused ? wasFocusedStyle : undefined}
          role="heading"
         
        >
          {placeholder}
        </C.InputLabel>
        {icon}
      </C.InputContainer>
      <C.ErrorMsg
        style={{ display: errorMsg ? "block" : "none" }}
        role={"alert"}
      >
        {errorMsg}
      </C.ErrorMsg>
    </C.MainContainer>
  );
}
